// The ticket that describes what is at the address now, out of all tickets of a task: the latest
// approved one, else the latest that is not cancelled, else the latest. A cancelled ticket can still
// carry products and serial numbers of work that was never finished, and a new ticket (another IPA)
// can install other products: adding all tickets up mixes the two.
const statusOf = (ticket) => ticket?.current_status ?? ticket?.ticket?.current_status

export function currentTicket(tickets) {
  const list = Object.entries(tickets || {})
    .map(([id, ticket]) => ({ id: Number(ticket?.ticketId ?? ticket?.ticket?.id ?? id) || 0, ticket }))
    .sort((a, b) => b.id - a.id)
    .map(({ ticket }) => ticket)
  return (
    list.find((t) => statusOf(t) === 'approved') ||
    list.find((t) => statusOf(t) !== 'cancelled') ||
    list[0] ||
    null
  )
}
